import LeftNav from "../../components/menu/left-nav";
import React, { useEffect, useRef, useState } from "react";
import classnames from "classnames";
import {
  Button,
  NavLink as NavLink1,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import SearchSVG from "../../components/svg/search-svg";
import CloseSVG from "../../components/svg/close-svg";
import { QueryRequestHelper } from "../../common/query-request-helper";
import { getValue } from "../../core/lodash";
import LoaderCommon from "../../components/common/loader-common";
import { useHistory } from "react-router";
import NoData from "../../components/Nodata";
import Pagination from "react-js-pagination";
import { getQueuedReports } from "../../core/services/locations.service";
import moment from "moment";
import { saveAs } from "file-saver";
import RefreshSVG from "../../components/svg/refresh-svg";

function SurveyLogs() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const history = useHistory();
  /* -------------------------------------------------------------------------- */
  /*                                tab/Nav Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLeftNav, manageLeftMenu] = useState(true);
  const [activeTab, setActiveTab] = useState("1");
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const collapseLeftNav = () => {
    manageLeftMenu(!isLeftNav);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (Object.keys(urlParams).length === 0) {
      getLogs();
    }
  }, []);
  useEffect(() => {
    if (Object.keys(urlParams).length > 0) {
      getLogs();
      if (getValue(urlParams, `text`, "")) {
        setSearchInput(getValue(urlParams, `text`, ""));
        openSearch(true);
      }
      if (getValue(urlParams, `skip`, "")) {
        setSkip(parseInt(getValue(urlParams, `skip`, "")));
      }
    }
  }, [window.location.href]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setUsersList] = React.useState<[]>([]);

  const getLogs = async () => {
    try {
      let payload: any = {
        skip: getValue(urlParams, `skip`, "0"),
        take: limit,
        sort: sort,
        text: getValue(urlParams, `text`, ""),
        report_type: "EXPORT_FEEDBACK_SUMMARY",
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getQueuedReports(queryRequest);
      console.log(resp);
      if (resp) {
        setIsLoading(false);
        setUsersList(getValue(resp, `data.reports`, []));
        setTotalCount(getValue(resp, `data.count`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             Pagination section                             */
  /* -------------------------------------------------------------------------- */
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [skip, setSkip] = useState<any>("0");
  const [sort, setSort] = useState("newest");

  const onProductPageChangeHandler = (pageNumber) => {
    if (pageNumber == 1) {
      setPageNumber(pageNumber);
      let skip = "0";
      setSkip(skip);
      let payload = {
        ...urlParams,
        skip: skip,
      };
      let queryRequest = QueryRequestHelper(payload);
      history.push(`${window.location.pathname}?${queryRequest}`);
    } else {
      setPageNumber(pageNumber);
      let skip = (pageNumber - 1) * 10;
      setSkip(skip);
      let payload = {
        ...urlParams,
        skip: skip,
      };
      let queryRequest = QueryRequestHelper(payload);
      history.push(`${window.location.pathname}?${queryRequest}`);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Search section                             */
  /* -------------------------------------------------------------------------- */

  const [search, openSearch] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const handleChangeSearch = (e) => {
    const { name, value } = e.target;
    setSearchInput(value);
    let payload = {
      ...urlParams,
      text: value,
    };
    let queryRequest = QueryRequestHelper(payload);
    history.push(`${window.location.pathname}?${queryRequest}`);
  };
  const toggleSearch = () => {
    openSearch(!search);
    setSearchInput("");
    delete urlParams.text;
    let payload = {
      ...urlParams,
    };
    let queryRequest = QueryRequestHelper(payload);
    history.push(`${window.location.pathname}?${queryRequest}`);
    if (searchInput) {
      getLogs();
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                                   Add section                              */
  /* -------------------------------------------------------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const intialState = {
    name: "",
    code: "",
    description: "",
    is_active: true,
  };
  const [request, setRequest] = useState(intialState);
  const reset = () => {
    setRequest({ ...request, ...intialState });
  };

  /* -------------------------------------------------------------------------- */
  /*                               Download section                             */
  /* -------------------------------------------------------------------------- */
  const handleDownload = async (url) => {
    try {
      saveAs(url, "Feedback-Report.pdf");
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div>
      <div className={"page-layout " + (isLeftNav ? "active" : "")}>
        <LeftNav
          isLeftNav={isLeftNav}
          collapseLeftNav={() => collapseLeftNav()}
        />
        <div className="page-height">
          <div className="create-survey-tabs create-survey-tabs-search d-flex justify-content-between align-items-center">
            <div>
              {/* <ul
                className="table-header-actions"
                onClick={() => {
                  reset();
                  toggleModal();
                }}
              >
                <li className="orange-circle">
                  <Button color="primary">
                    <AddSVG />
                  </Button>
                </li>
              </ul> */}
            </div>
            <div>
              <Nav pills className="basic-tabs pl-0">
                <NavItem>
                  <NavLink1
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Logs
                  </NavLink1>
                </NavItem>
              </Nav>
            </div>
            <div>
              <div className="hover-circle">
                <Button color="nothing" onClick={toggleSearch}>
                  <SearchSVG />
                </Button>
                <div className={"table-search " + (search ? "show" : "")}>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search"
                    onChange={handleChangeSearch}
                    value={searchInput}
                  />
                  <Button
                    color="nothing"
                    onClick={toggleSearch}
                    className="table-search-close"
                  >
                    <CloseSVG />
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="page-padding pt-0">
            {isLoading ? (
              <LoaderCommon />
            ) : getValue(list, `length`, 0) > 0 ? (
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Table className="table-custom">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item: object) => {
                        return (
                          <tr className="cursor-pointer">
                            <td>{getValue(item, `report_name`, "")}</td>
                            <td>{getValue(item, `job_id`, "")}</td>
                            <td>{getValue(item, `report_description`, "")}</td>
                            <td>
                              <span
                                className={`status-badge ${getValue(
                                  item,
                                  `queue_status`,
                                  ""
                                ).toLowerCase()}`}
                              >
                                {getValue(item, `queue_status`, "")}
                              </span>
                            </td>
                            <td>
                              {moment(getValue(item, `created_at`, "")).format(
                                "DD MMM YYYY"
                              )}
                            </td>
                            <td>
                              {getValue(item, `report_url`, null) &&
                              getValue(item, `queue_status`, "") ===
                                "COMPLETED" ? (
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={() =>
                                    handleDownload(
                                      getValue(item, `report_url`, "")
                                    )
                                  }
                                >
                                  Download
                                </Button>
                              ) : (
                                <a
                                  onClick={() => getLogs()}
                                  style={{ color: "blue", cursor: "pointer" }}
                                >
                                  Click to Refresh
                                </a>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </TabPane>
              </TabContent>
            ) : (
              <NoData />
            )}
          </div>
          {totalCount > 10 && (
            <div className="pagination-container">
              <div></div>
              <div className="d-flex align-items-center">
                <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={limit}
                  totalItemsCount={totalCount}
                  pageRangeDisplayed={5}
                  onChange={onProductPageChangeHandler}
                  prevPageText="Prev"
                  nextPageText="Next"
                  hideFirstLastPages={true}
                />
                <p className="mx-2">|</p>
                <h6>Total count : {totalCount}</h6>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SurveyLogs;
